import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../shared/confirm-dialog/confirm-dialog.component';
import {CookieConsentDialogComponent} from './cookie-consent-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {
  public dialogRef;
  constructor(public dialog: MatDialog) { }

  openCookieConsentDialog(){
    this.dialogRef = this.dialog.open(CookieConsentDialogComponent, {
      height: 'auto',
      width: '600px',
      panelClass: 'cookies-modal'
    });
  }
}
